import { useTranslator } from '@Localization';
import { ReactNode } from 'react';
import { S_ConfirmationModal } from '../../../design/modals/confirmationModal/S_ConfirmationModal';
import { ColumnLayout } from '../../common/layouts/columnLayout/ColumnLayout';
import { IJobDownload, JOB_DOWNLOAD_TYPE } from '../jobs.model';

interface JobDownloadModalProps {
  jobDownload: IJobDownload;
  onCancel: () => void;
  onSubmit: () => Promise<void>;
}

export const JobDownloadModal = ({ jobDownload, onCancel, onSubmit }: JobDownloadModalProps): ReactNode => {
  const { t } = useTranslator();

  return (
    <S_ConfirmationModal
      cancelText={t('cancel')}
      submitText={t(jobDownload.downloadType === JOB_DOWNLOAD_TYPE.MODEL ? 'download.button_model' : 'download.button_results')}
      onSubmit={onSubmit}
      onCancel={onCancel}
      headerText={t('threshold.changed')}
      isOpen={true}
    >
      <ColumnLayout size='sm'>
        <div>
          {t('threshold.original', {
            min: jobDownload.baseThresholdRange[0],
            max: jobDownload.baseThresholdRange[1],
          })}
        </div>
        <div>
          {t('threshold.updated', {
            min: jobDownload.currentThresholdRange[0],
            max: jobDownload.currentThresholdRange[1],
          })}
        </div>
      </ColumnLayout>
      <p>{t('threshold.use_original_values')}</p>
    </S_ConfirmationModal>
  );
};
